import React from 'react'
import _ from '/home/ps/root'
export const ID = 'loading'
const Loading = prop => {
  // Loading View {prop.vid || prop.db} {prop.v} {prop.pk}
  return (
    <h1 className={prop.className}>
      Loading
    </h1>
  )
}
Loading.ID = ID
export default Loading
